import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/mac.svg'
import _imports_1 from '@/assets/images/hours.svg'


const _hoisted_1 = { class: "container px-5 pb-5 client-schedule-page" }
const _hoisted_2 = { class: "fw-bold mb-3" }
const _hoisted_3 = { class: "section d-flex gap-4" }
const _hoisted_4 = { class: "calendar-wrapper" }
const _hoisted_5 = ["title"]
const _hoisted_6 = { class: "schedule-event-card__time" }
const _hoisted_7 = { class: "schedule-event-card__title" }
const _hoisted_8 = { class: "schedule-event-card schedule-event-card--month" }
const _hoisted_9 = { class: "schedule-event-card__time" }
const _hoisted_10 = { class: "schedule-event-card__title" }
const _hoisted_11 = { class: "sidebar" }
const _hoisted_12 = { class: "banner mb-4" }
const _hoisted_13 = ["title"]
const _hoisted_14 = { class: "card-info" }
const _hoisted_15 = { class: "title-card p-2" }
const _hoisted_16 = ["alt"]
const _hoisted_17 = { class: "mb-0 me-3 mx-2" }
const _hoisted_18 = { class: "body-card px-2 m-2 d-flex flex-column" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { key: 2 }
const _hoisted_22 = { class: "footer-card p-3 py-4" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, " arrow_forward ", -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = ["title"]
const _hoisted_26 = { class: "card-info" }
const _hoisted_27 = { class: "title-card p-2" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "hours"
}, null, -1)
const _hoisted_29 = { class: "mb-0 me-3 mx-2" }
const _hoisted_30 = { class: "body-card px-2 m-2" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", null, "Total:", -1)
const _hoisted_32 = { class: "footer-card p-3 py-4" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, " arrow_forward ", -1)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = {
  key: 0,
  class: "event-dialog-body"
}
const _hoisted_36 = { class: "event-dialog-section" }
const _hoisted_37 = { class: "event-dialog-section__title" }
const _hoisted_38 = { class: "event-dialog-section__time" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, "schedule", -1)
const _hoisted_40 = { class: "event-dialog-section" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("h6", { class: "event-dialog-section__title" }, "Rustdesk", -1)
const _hoisted_42 = { class: "event-dialog-row" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("b", null, "ID/Endereço local:", -1)
const _hoisted_44 = ["src"]
const _hoisted_45 = { class: "event-dialog-row" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("b", null, "ID/Endereço remoto:", -1)
const _hoisted_47 = ["src"]
const _hoisted_48 = { class: "event-dialog-row" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("b", null, "Senha:", -1)
const _hoisted_50 = ["src"]
const _hoisted_51 = { class: "event-dialog-section" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("h6", { class: "event-dialog-section__title" }, "Mac", -1)
const _hoisted_53 = { class: "event-dialog-row" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("b", null, "Usuário:", -1)
const _hoisted_55 = { class: "event-dialog-row" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("b", null, "Senha:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_Qalendar = _resolveComponent("Qalendar")!
  const _component_ds_button = _resolveComponent("ds-button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ConfirmDialog),
    _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.$t("schedule.mySchedules")), 1),
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Qalendar, {
          events: _ctx.schedules,
          config: _ctx.config,
          onEditEvent: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openEvent($event))),
          onDeleteEvent: _cache[1] || (_cache[1] = ($event: any) => (_ctx.confirmDelete($event))),
          onEventWasClicked: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openScheduleDialog($event)))
        }, {
          weekDayEvent: _withCtx(({ eventData }) => [
            _createElementVNode("div", {
              class: "schedule-event-card",
              title: `${eventData.title} · ${_ctx.formatEventTime(eventData.time.start)} - ${_ctx.formatEventTime(eventData.time.end)}`
            }, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.formatEventTime(eventData.time.start)) + " - " + _toDisplayString(_ctx.formatEventTime(eventData.time.end)), 1),
              _createElementVNode("span", _hoisted_7, _toDisplayString(eventData.title), 1)
            ], 8, _hoisted_5)
          ]),
          monthEvent: _withCtx(({ eventData }) => [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.formatEventTime(eventData.time.start)), 1),
              _createElementVNode("span", _hoisted_10, _toDisplayString(eventData.title), 1)
            ])
          ]),
          _: 1
        }, 8, ["events", "config"])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_ds_button, {
          class: "w-100",
          type: "primary",
          text: _ctx.$t('schedule.new'),
          leftIcon: "add",
          onClick: _cache[3] || (_cache[3] = () => _ctx.$router.push({ name: 'AddScheduleClient' }))
        }, null, 8, ["text"]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", {
            class: "card-banner h-100",
            title: _ctx.$t('financial.lookInstruction'),
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.goToMac(_ctx.nextDate.id)))
          }, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: _ctx.$t('financial.remoteMac')
                }, null, 8, _hoisted_16),
                _createElementVNode("h5", _hoisted_17, _toDisplayString(_ctx.$t("financial.remoteMac")), 1)
              ]),
              _createElementVNode("div", _hoisted_18, [
                (_ctx.nextDate.startDate)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_19, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("financial.days")) + ":", 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.nextDate.startDate), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.nextDate.startHour)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_20, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("financial.hour")) + ":", 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.nextDate.startHour) + " às " + _toDisplayString(_ctx.nextDate.endHour), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_21, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("financial.noReserve")), 1)
                    ]))
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t("financial.lookInstruction")), 1)
              ])
            ]),
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push({ name: 'BuyCredits' })))
            }, _hoisted_24)
          ], 8, _hoisted_13),
          _createElementVNode("div", {
            class: "card-banner",
            title: _ctx.$t('financial.buyCredits'),
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$router.push({ name: 'BuyCredits' })))
          }, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createElementVNode("h5", _hoisted_29, _toDisplayString(_ctx.$t("financial.creditsAvailable")), 1)
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("p", null, [
                  _hoisted_31,
                  _createTextVNode(" " + _toDisplayString(_ctx.currentBalance) + " " + _toDisplayString(_ctx.$t("computer.fields.credits")), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t("financial.buyCredits")), 1)
              ])
            ]),
            _createElementVNode("button", {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$router.push({ name: 'BuyCredits' })))
            }, _hoisted_34)
          ], 8, _hoisted_25)
        ])
      ])
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.showEventDialog,
      "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.showEventDialog) = $event)),
      modal: "",
      header: _ctx.$t('schedule.mySchedules'),
      class: "schedule-event-dialog",
      style: { width: '420px', maxWidth: '90vw' },
      breakpoints: { '991px': '70vw', '575px': '92vw' }
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_ds_button, {
          type: "primary",
          text: _ctx.$t('financial.lookInstruction'),
          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.goToMac(_ctx.selectedEvent.id)))
        }, null, 8, ["text"])
      ]),
      default: _withCtx(() => [
        (_ctx.selectedEvent)
          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("h6", _hoisted_37, _toDisplayString(_ctx.selectedEvent.title), 1),
                _createElementVNode("p", _hoisted_38, [
                  _hoisted_39,
                  _createTextVNode(" " + _toDisplayString(_ctx.formatEventDate(_ctx.selectedEvent.time.start)) + " · " + _toDisplayString(_ctx.formatEventTime(_ctx.selectedEvent.time.start)) + " - " + _toDisplayString(_ctx.formatEventTime(_ctx.selectedEvent.time.end)), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _hoisted_41,
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("span", null, [
                    _hoisted_43,
                    _createTextVNode(" " + _toDisplayString(_ctx.selectedEvent.alias), 1)
                  ]),
                  _createElementVNode("button", {
                    class: "copy-btn",
                    title: "copiar texto",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.copyText(_ctx.selectedEvent.alias)))
                  }, [
                    _createElementVNode("img", {
                      src: _ctx.copyIcon,
                      alt: "copiar"
                    }, null, 8, _hoisted_44)
                  ])
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("span", null, [
                    _hoisted_46,
                    _createTextVNode(" " + _toDisplayString(_ctx.selectedEvent.rustDeskId), 1)
                  ]),
                  _createElementVNode("button", {
                    class: "copy-btn",
                    title: "copiar texto",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.copyText(_ctx.selectedEvent.rustDeskId)))
                  }, [
                    _createElementVNode("img", {
                      src: _ctx.copyIcon,
                      alt: "copiar"
                    }, null, 8, _hoisted_47)
                  ])
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("span", null, [
                    _hoisted_49,
                    _createTextVNode(" " + _toDisplayString(_ctx.selectedEvent.apiPassword), 1)
                  ]),
                  _createElementVNode("button", {
                    class: "copy-btn",
                    title: "copiar texto",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.copyText(_ctx.selectedEvent.apiPassword)))
                  }, [
                    _createElementVNode("img", {
                      src: _ctx.copyIcon,
                      alt: "copiar"
                    }, null, 8, _hoisted_50)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_51, [
                _hoisted_52,
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("span", null, [
                    _hoisted_54,
                    _createTextVNode(" " + _toDisplayString(_ctx.selectedEvent.macUser), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("span", null, [
                    _hoisted_56,
                    _createTextVNode(" " + _toDisplayString(_ctx.selectedEvent.computerPassword), 1)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible", "header"])
  ]))
}